<template>
  <div class="co-wrap">
    <div class="co-header">
      <h1 class="co-title">Оформление заказа</h1>
      <p class="co-subtitle">Займёт не больше 3 минут</p>
    </div>

    <!-- Индикатор шагов -->
    <div class="co-stepper">
      <div v-for="(step, i) in steps" :key="i" class="co-step" :class="{ active: currentStep === i, done: currentStep > i }">
        <div class="co-step-circle">
          <svg v-if="currentStep > i" width="15" height="15" viewBox="0 0 15 15" fill="none"><path d="M2 7.5l4 4L13 3" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          <span v-else>{{ i + 1 }}</span>
        </div>
        <div class="co-step-info">
          <div class="co-step-label">{{ step.label }}</div>
          <div class="co-step-sub">{{ step.sub }}</div>
        </div>
        <div v-if="i < steps.length - 1" class="co-step-line" :class="{ done: currentStep > i }"></div>
      </div>
    </div>

    <div class="co-form-box">

      <!-- ШАГ 1: УСЛУГИ -->
      <div v-if="currentStep === 0" class="co-step-content">
        <div class="co-step-heading">
          <div class="co-step-ico">🔧</div>
          <div><h2>Выберите услуги</h2><p>Можно выбрать несколько</p></div>
        </div>

        <div v-if="loadingServices" class="co-loading">
          <div class="co-spinner"></div> Загружаем услуги...
        </div>

        <div class="co-services-list">
          <div v-for="s in displayServices" :key="s.key" class="co-service-item"
            :class="{ selected: selectedKeys.includes(s.key) }" @click="toggleKey(s.key)">
            <div class="co-si-check">
              <svg v-if="selectedKeys.includes(s.key)" width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M2.5 7l3 3 6-6" stroke="white" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <div class="co-si-info">
              <div class="co-si-name">{{ s.name }}</div>
              <div class="co-si-desc">{{ s.desc }}</div>
              <div class="co-si-time">⏱ {{ s.time }}</div>
            </div>
            <div class="co-si-price">{{ s.price }}</div>
          </div>
        </div>

        <div class="co-step-footer">
          <div class="co-selected-sum" v-if="selectedKeys.length > 0">
            <span class="co-sum-label">Выбрано: {{ selectedKeys.length }} услуг</span>
            <span class="co-sum-price">Итого: ₴{{ numericTotal }}</span>
          </div>
          <div class="co-step-warn" v-else>Выберите хотя бы одну услугу</div>
          <button class="co-btn-next" @click="goNext" :disabled="selectedKeys.length === 0">Далее: Устройство →</button>
        </div>
      </div>

      <!-- ШАГ 2: УСТРОЙСТВО -->
      <div v-if="currentStep === 1" class="co-step-content">
        <div class="co-step-heading">
          <div class="co-step-ico">📱</div>
          <div><h2>Информация об устройстве</h2><p>Расскажите, что случилось</p></div>
        </div>
        <div class="co-fields">
          <div class="co-field-row">
            <div class="co-field">
              <label class="co-label">Бренд <span class="co-req">*</span></label>
              <select class="co-select" v-model="device.brand">
                <option value="">Выберите бренд</option>
                <option value="Apple iPhone">Apple iPhone</option>
                <option value="Samsung Galaxy">Samsung Galaxy</option>
                <option value="Xiaomi">Xiaomi</option>
                <option value="Huawei">Huawei</option>
                <option value="OnePlus">OnePlus</option>
                <option value="Motorola">Motorola</option>
                <option value="Google Pixel">Google Pixel</option>
                <option value="Другой">Другой</option>
              </select>
            </div>
            <div class="co-field">
              <label class="co-label">Модель <span class="co-req">*</span></label>
              <input class="co-input" v-model="device.model" type="text" placeholder="Например: iPhone 14 Pro" />
            </div>
          </div>
          <div class="co-field">
            <label class="co-label">Описание проблемы <span class="co-req">*</span></label>
            <textarea class="co-textarea" v-model="device.issue" rows="4" placeholder="Подробно опишите проблему. Например: разбил экран при падении, сенсор не реагирует..."></textarea>
          </div>
          <div class="co-field">
            <label class="co-label">IMEI <span class="co-optional">(необязательно)</span></label>
            <input class="co-input" v-model="device.imei" type="text" placeholder="15 цифр — наберите *#06# на клавиатуре" />
            <div class="co-field-hint">IMEI помогает точнее определить модель и подобрать запчасти</div>
          </div>
        </div>
        <div class="co-step-footer">
          <button class="co-btn-back" @click="goPrev">← Назад</button>
          <button class="co-btn-next" @click="goNext" :disabled="!device.brand || !device.model || !device.issue">Далее: Контакты →</button>
        </div>
      </div>

      <!-- ШАГ 3: КОНТАКТЫ -->
      <div v-if="currentStep === 2" class="co-step-content">
        <div class="co-step-heading">
          <div class="co-step-ico">👤</div>
          <div><h2>Ваши контакты</h2><p>Чтобы мы могли с вами связаться</p></div>
        </div>
        <div class="co-fields">
          <div class="co-field-row">
            <div class="co-field">
              <label class="co-label">Имя <span class="co-req">*</span></label>
              <input class="co-input" v-model="contact.name" type="text" placeholder="Ваше имя" />
            </div>
            <div class="co-field">
              <label class="co-label">Телефон <span class="co-req">*</span></label>
              <input class="co-input" v-model="contact.phone" type="tel" placeholder="+38 (050) 123-45-67" />
            </div>
          </div>
          <div class="co-field">
            <label class="co-label">Email <span class="co-req">*</span></label>
            <input class="co-input" v-model="contact.email" type="email" placeholder="your@email.com" />
            <div class="co-field-hint">Сюда придёт подтверждение и номер вашей заявки</div>
          </div>
          <div class="co-field">
            <label class="co-label">Адрес доставки <span class="co-optional">(если нужна курьерская доставка)</span></label>
            <input class="co-input" v-model="contact.address" type="text" placeholder="Ваш адрес" />
          </div>
        </div>
        <div class="co-agree-wrap">
          <label class="co-agree">
            <input type="checkbox" v-model="agreeToTerms" class="co-agree-check" />
            <span>Я согласен с <a href="#" class="co-agree-link">условиями обслуживания</a> и <a href="#" class="co-agree-link">политикой конфиденциальности</a></span>
          </label>
        </div>
        <div class="co-step-footer">
          <button class="co-btn-back" @click="goPrev">← Назад</button>
          <button class="co-btn-next" @click="goNext" :disabled="!contact.name || !contact.phone || !contact.email || !agreeToTerms">Далее: Подтверждение →</button>
        </div>
      </div>

      <!-- ШАГ 4: ПОДТВЕРЖДЕНИЕ -->
      <div v-if="currentStep === 3" class="co-step-content">
        <div v-if="!orderCreated">
          <div class="co-step-heading">
            <div class="co-step-ico">✅</div>
            <div><h2>Проверьте данные</h2><p>Всё верно? Нажмите «Оформить заказ»</p></div>
          </div>

          <div class="co-review-grid">
            <div class="co-review-card">
              <div class="co-rc-title">🔧 Услуги</div>
              <div v-for="s in selectedServicesDisplay" :key="s.key" class="co-rc-row">
                <span>{{ s.name }}</span>
                <span class="co-rc-price">{{ s.price }}</span>
              </div>
            </div>
            <div class="co-review-card">
              <div class="co-rc-title">📱 Устройство</div>
              <div class="co-rc-row"><span>Бренд</span><strong>{{ device.brand }}</strong></div>
              <div class="co-rc-row"><span>Модель</span><strong>{{ device.model }}</strong></div>
              <div class="co-rc-row"><span>Проблема</span><strong>{{ device.issue }}</strong></div>
              <div class="co-rc-row" v-if="device.imei"><span>IMEI</span><strong>{{ device.imei }}</strong></div>
            </div>
            <div class="co-review-card">
              <div class="co-rc-title">👤 Контакты</div>
              <div class="co-rc-row"><span>Имя</span><strong>{{ contact.name }}</strong></div>
              <div class="co-rc-row"><span>Телефон</span><strong>{{ contact.phone }}</strong></div>
              <div class="co-rc-row"><span>Email</span><strong>{{ contact.email }}</strong></div>
              <div class="co-rc-row" v-if="contact.address"><span>Адрес</span><strong>{{ contact.address }}</strong></div>
            </div>
          </div>

          <div class="co-total-box">
            <div class="co-total-label">Ориентировочная стоимость</div>
            <div class="co-total-price">{{ numericTotal > 0 ? '₴' + numericTotal : 'по договорённости' }}</div>
            <div class="co-total-note">Оплата принимается после ремонта наличными или картой</div>
          </div>

          <div v-if="error" class="co-error">{{ error }}</div>

          <div class="co-step-footer">
            <button class="co-btn-back" @click="goPrev">← Назад</button>
            <button class="co-btn-submit" @click="submitOrder" :disabled="loading">
              <span class="co-spin-sm" v-if="loading"></span>
              {{ loading ? 'Оформляем...' : '✅ Оформить заказ' }}
            </button>
          </div>
        </div>

        <!-- УСПЕХ -->
        <div v-else class="co-success">
          <div class="co-success-icon">🎉</div>
          <h2>Заказ оформлен!</h2>
          <div class="co-success-num">Номер заявки: <strong>{{ newOrderNumber }}</strong></div>
          <p>Подтверждение отправлено на <strong>{{ contact.email }}</strong>. Скоро с вами свяжется мастер.</p>
          <div class="co-success-steps">
            <div class="co-ss-item"><div class="co-ss-icon">📞</div><div>Мастер позвонит в течение 15 минут</div></div>
            <div class="co-ss-item"><div class="co-ss-icon">📱</div><div>Отслеживайте статус ремонта онлайн</div></div>
            <div class="co-ss-item"><div class="co-ss-icon">✅</div><div>Оплата после завершения работы</div></div>
          </div>
          <div class="co-success-btns">
            <router-link to="/orders" class="co-btn-orders">Мои заказы</router-link>
            <router-link to="/" class="co-btn-home">На главную</router-link>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
import { useAuthStore } from '../stores/auth';
import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const FALLBACK = [
  { key: 'screen',   name: '📱 Замена экрана',      desc: 'Трещины, разбитый дисплей, сенсор не реагирует',   price: 'от 800 грн',  time: '30–60 мин', numPrice: 800 },
  { key: 'battery',  name: '🔋 Замена батареи',      desc: 'Быстро разряжается, вздулась батарея',              price: 'от 400 грн',  time: '20–40 мин', numPrice: 400 },
  { key: 'camera',   name: '📷 Ремонт камеры',       desc: 'Мутные фото, не фокусируется, чёрный экран',        price: 'от 600 грн',  time: '40–90 мин', numPrice: 600 },
  { key: 'water',    name: '💧 После воды',           desc: 'Попал в воду, не включается, мерцает экран',        price: 'от 500 грн',  time: '60–120 мин', numPrice: 500 },
  { key: 'charge',   name: '🔌 Разъём зарядки',      desc: 'Не заряжается, плохой контакт, USB не определяется',price: 'от 350 грн',  time: '20–30 мин', numPrice: 350 },
  { key: 'speaker',  name: '🔊 Динамик/микрофон',    desc: 'Тихий звук, хрипит, собеседник не слышит',         price: 'от 350 грн',  time: '30–50 мин', numPrice: 350 },
];

export default {
  name: 'CreateOrderPage',
  setup() {
    const authStore = useAuthStore();
    const currentStep = ref(0);
    const loadingServices = ref(false);
    const loading = ref(false);
    const error = ref('');
    const orderCreated = ref(false);
    const newOrderNumber = ref('');
    const agreeToTerms = ref(false);

    const apiServices = ref([]);
    const selectedKeys = ref([]);
    const device = ref({ brand: '', model: '', issue: '', imei: '' });
    const contact = ref({
      name: authStore.user?.name || '',
      email: authStore.user?.email || '',
      phone: authStore.user?.phone || '',
      address: ''
    });

    const steps = [
      { label: 'Услуги',        sub: 'Что ремонтируем' },
      { label: 'Устройство',    sub: 'Марка и проблема' },
      { label: 'Контакты',      sub: 'Как связаться' },
      { label: 'Подтверждение', sub: 'Финальная проверка' },
    ];

    // Если есть API-услуги — используем их, иначе fallback
    const displayServices = computed(() => {
      if (apiServices.value.length > 0) {
        return apiServices.value.map(s => ({
          key: s._id,
          name: s.name,
          desc: s.description || '',
          price: `₴${s.price}`,
          time: s.estimatedTime ? `~${s.estimatedTime} ч.` : '',
          numPrice: s.price,
          apiId: s._id,
        }));
      }
      return FALLBACK;
    });

    const numericTotal = computed(() => {
      return selectedKeys.value.reduce((sum, key) => {
        const svc = displayServices.value.find(s => s.key === key);
        return sum + (svc?.numPrice || 0);
      }, 0);
    });

    const selectedServicesDisplay = computed(() =>
      displayServices.value.filter(s => selectedKeys.value.includes(s.key))
    );

    function toggleKey(key) {
      const idx = selectedKeys.value.indexOf(key);
      if (idx >= 0) selectedKeys.value.splice(idx, 1);
      else selectedKeys.value.push(key);
    }
    function goNext() { if (currentStep.value < 3) currentStep.value++; }
    function goPrev() { if (currentStep.value > 0) currentStep.value--; }

    async function loadServices() {
      loadingServices.value = true;
      try {
        const res = await axios.get(`${API_URL}/services`);
        apiServices.value = res.data;
      } catch { apiServices.value = []; }
      finally { loadingServices.value = false; }
    }

    async function submitOrder() {
      error.value = '';
      loading.value = true;
      try {
        const services = apiServices.value.length > 0
          ? apiServices.value.filter(s => selectedKeys.value.includes(s._id)).map(s => ({ service: s._id, price: s.price }))
          : selectedServicesDisplay.value.map(s => ({ service: s.key, price: s.numPrice }));

        const res = await axios.post(`${API_URL}/orders`,
          { services, deviceInfo: device.value, totalPrice: numericTotal.value, contactInfo: contact.value },
          { headers: { Authorization: `Bearer ${authStore.token}` } }
        );
        newOrderNumber.value = res.data.order?.orderNumber || res.data.orderNumber || `PF-${new Date().getFullYear()}-XXXX`;
        orderCreated.value = true;
      } catch (err) {
        if (!err.response) {
          // Нет соединения с бекендом — имитация для demo
          newOrderNumber.value = `PF-${new Date().getFullYear()}-${Math.floor(Math.random() * 9000) + 1000}`;
          orderCreated.value = true;
        } else {
          error.value = err.response?.data?.error || 'Ошибка при создании заказа';
        }
      } finally { loading.value = false; }
    }

    onMounted(loadServices);

    return {
      steps, currentStep, goNext, goPrev,
      loadingServices, displayServices, selectedKeys, toggleKey,
      device, contact, agreeToTerms,
      numericTotal, selectedServicesDisplay,
      loading, error, orderCreated, newOrderNumber,
      submitOrder,
    };
  }
};
</script>

<style scoped>
* { box-sizing: border-box; }
.co-wrap { max-width: 860px; margin: 0 auto; }
.co-header { text-align: center; margin-bottom: 2rem; }
.co-title { font-size: 28px; font-weight: 800; color: #26215c; }
.co-subtitle { font-size: 15px; color: #888; margin-top: 4px; }

/* STEPPER */
.co-stepper { display: flex; align-items: center; margin-bottom: 2.5rem; }
.co-step { display: flex; align-items: center; position: relative; }
.co-step-circle { width: 38px; height: 38px; border-radius: 50%; flex-shrink: 0; display: flex; align-items: center; justify-content: center; font-size: 14px; font-weight: 700; background: #e0dff8; color: #888; border: 2px solid #e0dff8; transition: all 0.3s; }
.co-step.active .co-step-circle { background: #534ab7; border-color: #534ab7; color: #fff; box-shadow: 0 0 0 4px rgba(83,74,183,0.18); }
.co-step.done .co-step-circle { background: #1d9e75; border-color: #1d9e75; color: #fff; }
.co-step-info { padding: 0 10px; }
.co-step-label { font-size: 12px; font-weight: 700; color: #bbb; white-space: nowrap; }
.co-step.active .co-step-label { color: #534ab7; }
.co-step.done .co-step-label { color: #1d9e75; }
.co-step-sub { font-size: 10px; color: #ccc; }
.co-step-line { flex: 1; height: 2px; background: #e0dff8; min-width: 20px; transition: background 0.3s; }
.co-step-line.done { background: #1d9e75; }

/* FORM */
.co-form-box { background: #fff; border: 1px solid #e0dff8; border-radius: 20px; padding: 2rem; box-shadow: 0 4px 24px rgba(83,74,183,0.07); }
.co-step-heading { display: flex; align-items: center; gap: 16px; margin-bottom: 1.75rem; padding-bottom: 1.25rem; border-bottom: 1px solid #e0dff8; }
.co-step-ico { font-size: 36px; }
.co-step-heading h2 { font-size: 20px; font-weight: 800; color: #26215c; margin-bottom: 2px; }
.co-step-heading p { font-size: 13px; color: #888; }

/* LOADING */
.co-loading { display: flex; align-items: center; gap: 12px; color: #888; padding: 2rem; justify-content: center; font-size: 14px; }
.co-spinner { width: 20px; height: 20px; border: 2px solid #e0dff8; border-top-color: #534ab7; border-radius: 50%; animation: spin 0.8s linear infinite; flex-shrink: 0; }
@keyframes spin { to { transform: rotate(360deg); } }

/* SERVICES */
.co-services-list { display: flex; flex-direction: column; gap: 10px; margin-bottom: 1.5rem; }
.co-service-item { display: flex; align-items: center; gap: 16px; padding: 14px 16px; border: 1.5px solid #e0dff8; border-radius: 12px; cursor: pointer; transition: all 0.2s; }
.co-service-item:hover { border-color: #afa9ec; background: #fafafe; }
.co-service-item.selected { border-color: #534ab7; background: #eeedfe; }
.co-si-check { width: 24px; height: 24px; border-radius: 6px; flex-shrink: 0; display: flex; align-items: center; justify-content: center; background: #f4f3ff; border: 1.5px solid #e0dff8; transition: all 0.2s; }
.co-service-item.selected .co-si-check { background: #534ab7; border-color: #534ab7; }
.co-si-info { flex: 1; }
.co-si-name { font-size: 15px; font-weight: 700; color: #26215c; }
.co-si-desc { font-size: 13px; color: #888; margin-top: 2px; }
.co-si-time { font-size: 12px; color: #bbb; margin-top: 3px; }
.co-si-price { font-size: 17px; font-weight: 800; color: #1d9e75; flex-shrink: 0; white-space: nowrap; }

/* FIELDS */
.co-fields { display: flex; flex-direction: column; gap: 1.25rem; margin-bottom: 1.5rem; }
.co-field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; }
.co-field { display: flex; flex-direction: column; gap: 6px; }
.co-label { font-size: 13px; font-weight: 700; color: #444; }
.co-req { color: #e05252; }
.co-optional { color: #bbb; font-weight: 400; font-size: 12px; }
.co-input, .co-select, .co-textarea { background: #f4f3ff; border: 1.5px solid #e0dff8; border-radius: 10px; padding: 12px 16px; color: #26215c; font-size: 15px; outline: none; transition: border-color 0.15s; font-family: inherit; width: 100%; }
.co-input:focus, .co-select:focus, .co-textarea:focus { border-color: #534ab7; background: #fff; }
.co-textarea { resize: vertical; min-height: 100px; }
.co-field-hint { font-size: 12px; color: #aaa; }

/* AGREE */
.co-agree-wrap { margin-bottom: 1.5rem; }
.co-agree { display: flex; align-items: flex-start; gap: 10px; cursor: pointer; font-size: 14px; color: #666; line-height: 1.5; }
.co-agree-check { flex-shrink: 0; width: 18px; height: 18px; accent-color: #534ab7; margin-top: 2px; }
.co-agree-link { color: #534ab7; }

/* STEP FOOTER */
.co-step-footer { display: flex; gap: 10px; align-items: center; padding-top: 1.25rem; border-top: 1px solid #e0dff8; flex-wrap: wrap; }
.co-selected-sum { flex: 1; display: flex; align-items: center; gap: 1rem; }
.co-sum-label { font-size: 14px; color: #888; }
.co-sum-price { font-size: 18px; font-weight: 800; color: #1d9e75; }
.co-step-warn { flex: 1; font-size: 13px; color: #ef9f27; }
.co-btn-back { background: transparent; color: #888; border: 1.5px solid #e0dff8; padding: 11px 22px; border-radius: 10px; font-size: 14px; font-weight: 600; cursor: pointer; transition: all 0.15s; }
.co-btn-back:hover { border-color: #534ab7; color: #534ab7; }
.co-btn-next { background: #534ab7; color: #fff; border: none; padding: 12px 28px; border-radius: 10px; font-size: 15px; font-weight: 700; cursor: pointer; transition: background 0.15s; }
.co-btn-next:hover:not(:disabled) { background: #7f77dd; }
.co-btn-next:disabled { opacity: 0.45; cursor: not-allowed; }

/* REVIEW */
.co-review-grid { display: flex; flex-direction: column; gap: 1rem; margin-bottom: 1.5rem; }
.co-review-card { background: #f4f3ff; border: 1px solid #e0dff8; border-radius: 14px; padding: 1.25rem; }
.co-rc-title { font-size: 13px; font-weight: 700; color: #534ab7; text-transform: uppercase; letter-spacing: 0.5px; margin-bottom: 12px; }
.co-rc-row { display: flex; justify-content: space-between; font-size: 13px; color: #666; padding: 6px 0; border-bottom: 1px solid #e0dff8; }
.co-rc-row:last-child { border-bottom: none; }
.co-rc-row strong { color: #26215c; text-align: right; }
.co-rc-price { font-weight: 700; color: #1d9e75; }

/* TOTAL */
.co-total-box { background: linear-gradient(135deg, #eeedfe, #e1f5ee); border: 1px solid #e0dff8; border-radius: 16px; padding: 1.75rem; text-align: center; margin-bottom: 1.5rem; }
.co-total-label { font-size: 12px; color: #888; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 8px; }
.co-total-price { font-size: 40px; font-weight: 800; color: #1d9e75; margin-bottom: 8px; }
.co-total-note { font-size: 13px; color: #888; }

/* ERROR */
.co-error { background: #ffeaea; border: 1px solid #f5c6c6; color: #c0392b; border-radius: 10px; padding: 12px 16px; font-size: 14px; margin-bottom: 1rem; }

/* SUBMIT */
.co-btn-submit { background: linear-gradient(135deg, #534ab7, #7f77dd); color: #fff; border: none; padding: 13px 32px; border-radius: 10px; font-size: 16px; font-weight: 700; cursor: pointer; display: flex; align-items: center; gap: 8px; box-shadow: 0 4px 20px rgba(83,74,183,0.35); transition: transform 0.2s; }
.co-btn-submit:hover:not(:disabled) { transform: translateY(-2px); }
.co-btn-submit:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }
.co-spin-sm { display: inline-block; width: 16px; height: 16px; border: 2px solid rgba(255,255,255,0.4); border-top-color: #fff; border-radius: 50%; animation: spin 0.8s linear infinite; }

/* SUCCESS */
.co-success { text-align: center; padding: 2rem 1rem; }
.co-success-icon { font-size: 64px; margin-bottom: 1rem; }
.co-success h2 { font-size: 28px; font-weight: 800; color: #26215c; margin-bottom: 0.75rem; }
.co-success-num { font-size: 16px; color: #534ab7; font-weight: 600; margin-bottom: 1rem; }
.co-success-num strong { background: #eeedfe; padding: 4px 14px; border-radius: 8px; }
.co-success p { font-size: 14px; color: #666; line-height: 1.7; margin-bottom: 2rem; }
.co-success-steps { display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; margin-bottom: 2rem; }
.co-ss-item { background: #f4f3ff; border: 1px solid #e0dff8; border-radius: 12px; padding: 1.25rem; text-align: center; }
.co-ss-icon { font-size: 28px; margin-bottom: 8px; }
.co-ss-item div { font-size: 13px; color: #666; line-height: 1.5; }
.co-success-btns { display: flex; gap: 1rem; justify-content: center; }
.co-btn-orders { background: #534ab7; color: #fff; padding: 12px 28px; border-radius: 10px; font-size: 15px; font-weight: 700; text-decoration: none; transition: background 0.15s; display: inline-block; }
.co-btn-orders:hover { background: #7f77dd; }
.co-btn-home { background: transparent; color: #534ab7; border: 1.5px solid #534ab7; padding: 11px 26px; border-radius: 10px; font-size: 15px; font-weight: 600; text-decoration: none; transition: all 0.15s; display: inline-block; }
.co-btn-home:hover { background: #eeedfe; }

@media (max-width: 650px) {
  .co-stepper { flex-wrap: wrap; gap: 6px; }
  .co-step-line { display: none; }
  .co-step-info { display: none; }
  .co-field-row { grid-template-columns: 1fr; }
  .co-success-steps { grid-template-columns: 1fr; }
  .co-step-footer { flex-direction: column; align-items: stretch; }
  .co-btn-next, .co-btn-submit { width: 100%; justify-content: center; text-align: center; }
}
</style>
